import { Component, Input, OnInit } from '@angular/core';
import { userType } from 'src/app/constants/global-constants';
import { IBookingRequestResponse } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardService } from 'src/app/services/dashboard.service';
declare var $: any;

@Component({
  selector: 'app-book-an-appointment',
  templateUrl: './book-an-appointment.component.html',
  styleUrls: ['./book-an-appointment.component.scss']
})
export class BookAnAppointmentComponent implements OnInit {
  
  loggedIn: boolean;
  userType = userType;
  @Input() midwifeId: number;
  message: string = '';

  constructor(public authService: AuthService,
    public dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.loggedIn = this.authService.user?.userType==this.userType.MUM ? true : false;
  }

  bookAppointment(){
    let body = {
      midwifeId: this.midwifeId,
      message: this.message
    };
    this.dashboardService.createBookingRequest(body)
    .subscribe((res: IBookingRequestResponse)=>{
      $('#request-sent-modal').modal('show');
      this.message = '';
      console.log("Appointment Booked:", res);
    },err=>{
      console.error("Appointment Error:", err);
    });
  }

}
